// extracted by mini-css-extract-plugin
export default {"icon":"RandomJoke_icon__r-DfF","rotate":"RandomJoke_rotate__A1IHF","iconAnimation":"RandomJoke_iconAnimation__yBDr9"};